// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"e2df7dd6","208":"6496d4e7","416":"4d72c985","944":"30b5f365"}[chunkId] + ".chunk.js";
};